/**
 * Texts of the chat (the main map's chat button and panel: src/game/runtime/chat.ts, src/game/ui/chat-panel.ts). As
 * everywhere in the game, the Russian text is the source and the translation key (src/game/runtime/i18n.ts); the
 * translations are in tools/i18n/extra.json. Templates with {placeholders} are translated as a whole and the values put
 * in afterwards (clan-texts.ts compose); messages, nicknames and clan names are data and are never translated.
 */

export const MSG_CHAT = 'Чат';
export const MSG_CHAT_GLOBAL = 'Общий';
export const MSG_CHAT_CLAN = 'Клан';
export const MSG_CHAT_SEND = 'Отправить';
export const MSG_CHAT_PLACEHOLDER = 'Напишите сообщение…';
export const MSG_CHAT_LOADING = 'Загрузка…';
export const MSG_CHAT_EMPTY = 'Сообщений пока нет. Напишите первым!';
/** The empty chat of a player who cannot write in it (a guest, below the level, muted). */
export const MSG_CHAT_EMPTY_READ = 'Сообщений пока нет.';
export const MSG_CHAT_LOAD_FAILED = 'Не удалось загрузить чат. Попробуйте ещё раз.';
export const MSG_CHAT_SEND_FAILED = 'Не удалось отправить. Попробуйте ещё раз.';
export const MSG_CHAT_TOO_FAST = 'Слишком часто. Подождите немного.';
export const MSG_CHAT_DUPLICATE = 'Это сообщение уже отправлено.';
export const MSG_CHAT_TEXT_EMPTY = 'Сообщение пустое.';
export const TPL_CHAT_TEXT_TOO_LONG = 'Сообщение длиннее {max} символов.';
export const MSG_CHAT_NOT_MEMBER = 'Вы больше не в этом клане.';
export const MSG_CHAT_GUEST = 'Гости только читают чат. Зарегистрируйтесь, чтобы писать.';
export const TPL_CHAT_LEVEL = 'Писать в чат можно с {level} уровня.';
export const TPL_CHAT_MUTED = 'Вам запрещено писать в чат до {time}.';
export const MSG_CHAT_OFFLINE = 'Нет связи с сервером…';
export const TPL_CHAT_NEW = 'Новых: {n}';
export const TPL_CHAT_LEVEL_SHORT = 'ур. {level}';
export const TPL_CHAT_HIDE = 'Скрыть сообщения игрока {name}';
export const MSG_CHAT_CANCEL = 'Отмена';
export const TPL_CHAT_HIDDEN_DONE = 'Сообщения игрока {name} скрыты.';
export const TPL_CHAT_HIDDEN_LIST = 'Скрытые игроки ({n})';
export const MSG_CHAT_HIDDEN_NONE = 'Скрытых игроков нет.';
export const MSG_CHAT_SHOW_AGAIN = 'Показать';
export const MSG_CHAT_BACK = 'Назад';
export const MSG_CHAT_HIDDEN_HINT = 'Список скрытых игроков хранится только на этом устройстве.';
